import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

// type:content keeps these in the wide content column. The catalog/org info
// cards (graph, ownership, labels) declare type:info in app-config, which turns
// the entity layout into a 2fr/1fr grid. Stating type:content here makes the
// column placement intentional and stable rather than relying on the default.
const membersRolesCard = EntityCardBlueprint.make({
  name: 'members-roles',
  params: {
    filter: { kind: 'group' },
    loader: () =>
      import('./components/members-roles-card/members-roles-card').then(m => (
        <m.MembersRolesCard />
      )),
    type: 'content',
  },
});

const teamMembershipsCard = EntityCardBlueprint.make({
  name: 'team-memberships',
  params: {
    filter: { kind: 'user' },
    loader: () =>
      import('./components/team-memberships-card/team-memberships-card').then(
        m => <m.TeamMembershipsCard />,
      ),
    type: 'content',
  },
});

const nsTeamcentraalCatalogPlugin: FrontendPlugin = createFrontendPlugin({
  extensions: [membersRolesCard, teamMembershipsCard],
  pluginId: 'ns-teamcentraal-catalog',
});

export default nsTeamcentraalCatalogPlugin;

// Entity Cards
export { MembersRolesCard } from './components/members-roles-card/members-roles-card';
export { TeamMembershipsCard } from './components/team-memberships-card/team-memberships-card';

// Presentational + parsing exports for downstream reuse / Storybook.
export type {
  CounterSideKind,
  MembershipTableContentProps,
} from './components/membership-table-content';
export { MembershipTableContent } from './components/membership-table-content';
export type {
  ParsedMembershipAnnotation,
  ParsedRoleRow,
} from './parsing/parse-membership-annotation';
export { parseMembershipAnnotation } from './parsing/parse-membership-annotation';
